import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import history from '../history';

import authenticationReducer from './authenticationReducer';
import miscellaneousReducer from './miscellaneousReducer';
import organisationReducer from './organisationReducer';
import userReducer from './userReducer';
import roleReducer from './roleReducer';
import meshReducer from './meshReducer';
import controllerReducer from './controllerReducer';
import firePanelReducer from './firepanelReducer';
import showModalReducer from './showModal';
import readersReducer from './readersReducer';
import credentialReducer from './credentialsReducer';


const authPersistConfig = {
  key: 'auth',
  storage: storage,
  blacklist: ['miscellaneous'],
};

const rootReducer = combineReducers({
  router: connectRouter(history),
  auth: persistReducer(authPersistConfig, authenticationReducer),
  miscellaneous: miscellaneousReducer,
  organisation: organisationReducer,
  user: userReducer,
  role: roleReducer,
  mesh: meshReducer,
  controller: controllerReducer,
  firepanel: firePanelReducer,
  modal: showModalReducer,
  readers: readersReducer,
  credentials: credentialReducer
});


export default rootReducer;
